export default __webpack_public_path__ + "static/media/2.ce6a0451.jpg";